import React, { JSX, useMemo } from 'react';

import { ApiBooking, ApiTraveler } from '@ibe/api';
import CheckoutStore, { ProductIBEMode } from '../../../../Pages/Checkout/CheckoutStore';
import { defaultSteps, busTripSteps } from './steps';
import CollapsibleWizardWithProvider from '../CollapsibleWizard/CollapsibleWizard';
import FixedBottomBar from './FixedBottomBar';
import { ExtendedBookingProvider, extendedBookingStorage } from './ContextAndProvider';
import { PackageTypes } from '../../../Products/ProductIBE';

interface Props {
  booking: ApiBooking;
  next: () => void;
  disabled: boolean;
  loading: boolean;
  productIBEMode?: ProductIBEMode;
  store: CheckoutStore;
  showPromotionCode?: boolean;
  handleBookingError?: (errorMessage: string) => void;
  travelers?: ApiTraveler[];
  render: (a: JSX.Element) => JSX.Element;
  isWhitelabel?: boolean;
}

const ExtendedBooking = ({ store, render, ...props }: Props) => {
  const steps = useMemo(() => {
    const packageType = store.packageType ?? sessionStorage.getItem('packageType');
    const collapsibleSteps = packageType === PackageTypes.PBUS ? busTripSteps : defaultSteps;
    const storageSteps = extendedBookingStorage.get()?.steps;
    if (storageSteps && storageSteps?.length) {
      return storageSteps.flatMap((storageStep, index) => {
        return { ...storageStep, component: collapsibleSteps[index].component };
      });
    }
    return collapsibleSteps.flatMap((step, index) => ({
      ...step,
      component: collapsibleSteps[index].component
    }));
  }, []);

  const collapsibleWizard = (
    <CollapsibleWizardWithProvider items={steps}>
      <FixedBottomBar store={store} {...props} />
    </CollapsibleWizardWithProvider>
  );
  return (
    <ExtendedBookingProvider store={store}>{render(collapsibleWizard)}</ExtendedBookingProvider>
  );
};
export default ExtendedBooking;
